module.exports = __webpack_public_path__ + "6e7740388e3e5006ad2a80ec01fb67bd.svg";